const colors = ["blue", "cyan", "magenta", "lime", "maroon", "navy", "olive", "teal", "violet", "silver", "gold", "indigo", "coral", "crimson", "fuchsia", "khaki", "lavender", "plum", "turquoise", "wheat", "beige", "azure", "aliceblue", "aquamarine", "bisque", "blanchedalmond", "blueviolet", "burlywood", "cadetblue", "chartreuse", "chocolate", "cornflowerblue", "cornsilk", "darkblue", "darkcyan", "darkgoldenrod", "darkgray", "darkgreen", "darkgrey", "darkkhaki", "darkmagenta", "darkolivegreen", "darkorange", "darkorchid", "darkred", "darksalmon", "darkseagreen", "darkslateblue", "darkslategray", "darkslategrey", "darkturquoise", "darkviolet", "deeppink", "deepskyblue", "dimgray", "dimgrey", "dodgerblue", "firebrick", "forestgreen", "gainsboro", "gold", "goldenrod", "greenyellow", "honeydew", "hotpink", "indianred", "ivory", "lavenderblush", "lawngreen", "lemonchiffon", "lightblue", "lightcoral", "lightcyan", "lightgoldenrodyellow", "lightgray", "lightgreen", "lightgrey", "lightpink", "lightsalmon", "lightseagreen", "lightskyblue", "lightslategray", "lightslategrey", "lightsteelblue", "lightyellow", "limegreen", "linen", "mediumaquamarine", "mediumblue", "mediumorchid", "mediumpurple", "mediumseagreen", "mediumslateblue", "mediumspringgreen", "mediumturquoise", "mediumvioletred", "midnightblue", "mintcream", "mistyrose", "moccasin", "navajowhite", "oldlace", "ol"]

export const getNextMembers = (team, userId, currentLevel = 'ideaMaker') => {
    try {
        const map = {
            ideaMaker: 'researcher',
            researcher: 'scripter',
            scripter: 'producer',
        }
        const member = team.members.find(member => member._id === userId)
        const isAdmin = member.roles.includes('admin')
        if (!isAdmin) return false
        const nextMembers = team.members.filter(member => member.roles.includes(map[currentLevel])) || []
        const nextDepartments = Object.values(team.departments || {}).filter(department => department.type === map[currentLevel]) || []
        return nextMembers.concat([member]).concat(nextDepartments)
    }
    catch (error) {
        console.log(error)
        return false
    }
}

export function formatDate(dateObj) {
    dateObj = new Date(dateObj)
    const now = new Date()
    const isToday =
        dateObj.getDate() === now.getDate() &&
        dateObj.getMonth() === now.getMonth() &&
        dateObj.getFullYear() === now.getFullYear()

    const pad = (n) => String(n).padStart(2, '0')
    const timeStr = `${pad(dateObj.getHours())}:${pad(dateObj.getMinutes())}`

    if (isToday) return timeStr

    else {
        const dateStr = `${pad(dateObj.getDate())}/${pad(dateObj.getMonth() + 1)}/${dateObj.getFullYear()}`
        return `${dateStr} ${timeStr}`
    }
}


export function getMembersForDepartment(departmentMembers, allMembers) {
    try {
        const members = allMembers.filter(member => !(departmentMembers[member._id] || member.roles.includes('admin') || member.roles.includes('thumbnailEditor')))
        return members
    }
    catch {
        return []
    }
}

export function getReplacementMembers(team, level, currentEntityId) {
    const members = team.members.filter(m => (m.roles.includes(level) || m.roles.includes('admin')) && m._id !== currentEntityId)
    const departments = Object.values(team.departments || {}).filter(department => department.type === level && department.name !== currentEntityId)
    return members.concat(departments)
}

export function getCookie(name) {
    const cookies = document.cookie.split('; ')
    for (const cookie of cookies) {
        const [key, value] = cookie.split('=')
        if (key === name) return decodeURIComponent(value)
    }
    return null
}


export function createNewTableItem() {
    return {
        item: '',
        price: '',
        status: 'לא התחיל',
        links: [],
        info: '',
        isAlerted: false,
        id: Date.now(),
        importance: 'לא חובה',
        lastUpdatedAt: new Date(),
    }
}

export function calculateDaysDifference(date) {
    try {
        if (!date) return null
        const today = new Date()
        const recievedAt = new Date(date)
        const diffTime = Math.abs(today - recievedAt)
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
        return diffDays
    }
    catch {
        return null
    }
}

export function capitalizeFirst(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export function makeId(length = 6) {
    var txt = '';
    var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

    for (var i = 0; i < length; i++) {
        txt += possible.charAt(Math.floor(Math.random() * possible.length));
    }

    return txt;
}

export function getRandomIntInclusive(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min
}

export function getRandomFloat(min, max) {
    return (Math.random() * (max - min)) + min
}

export function delay(ms = 1500) {
    return new Promise(resolve => {
        setTimeout(resolve, ms)
    })
}

export function getUsPrice(price) {
    return Math.floor((price)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}
export function make2digits(num) {
    return num < 10 ? `0${num}` : num
}

export function putKandM(num) {
    if (num > 1000000) return (num / 1000000).toFixed(1) + 'M'
    if (num > 1000) return (num / 1000).toFixed(1) + 'K'
    return num
}

export function makeCommas(num) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export function formatDateHour(date = new Date()) {
    const d = new Date(date)
    return `${make2digits(d.getHours())}:${make2digits(d.getMinutes())} - ${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`
}

export function getRandomColor(inputString) {
    let hash = 0;
    for (let i = 0; i < inputString.length; i++) {
        hash = (hash << 5) - hash + inputString.charCodeAt(i)
        hash |= 0
    }
    const colorIndex = Math.abs(hash) % colors.length
    return colors[colorIndex]
}

